import React, { useRef, useState, useEffect } from 'react';
import {
  Button,
  ButtonProps,
  CircularProgress,
  Menu,
  MenuItem
} from '@material-ui/core';
import { ArrowDropDown as ArrowDropDownIcon } from '@material-ui/icons';
import AppSnackbar from '../../../common/AppSnackbar';
import { useExportCapaDocument } from '../Capa.hook';
import { Capa } from '../Capa.interface';

export interface CapaExportButtonProps {
  capa: Capa;
  buttonProps?: ButtonProps;
}

const CapaExportButton: React.FC<CapaExportButtonProps> = (
  props: CapaExportButtonProps
) => {
  const { capa, buttonProps } = props;
  const extensionRef = useRef<'docx' | 'pdf'>('docx');
  const [menuAnchorEl, setMenuAnchorEl] = useState<HTMLElement | null>(null);

  const [{ isLoading, error, response }, getDocument, downloadDocument] =
    useExportCapaDocument(capa?.id || 0);

  const getDocumentAs = (extension: 'docx' | 'pdf') => {
    extensionRef.current = extension;
    getDocument(extension);
  };

  useEffect(() => {
    if (response?.ok && capa) {
      downloadDocument(`CAPA - ${capa.id}.${extensionRef.current}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [response]);

  return (
    <>
      <AppSnackbar severity='error' open={!!error}>
        {error?.message || 'An error occurred while exporting the document.'}
      </AppSnackbar>
      <Button
        color='primary'
        variant='contained'
        endIcon={
          isLoading ? (
            <CircularProgress color='primary' size={20} />
          ) : (
            <ArrowDropDownIcon />
          )
        }
        {...buttonProps}
        disabled={isLoading || buttonProps?.disabled}
        onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
          setMenuAnchorEl(event.currentTarget);
        }}
      >
        Export
      </Button>
      <Menu
        id='capa-export-menu'
        keepMounted
        open={!!menuAnchorEl}
        anchorEl={menuAnchorEl}
        onClose={() => setMenuAnchorEl(null)}
      >
        <MenuItem
          onClick={() => {
            setMenuAnchorEl(null);
            getDocumentAs('docx');
          }}
        >
          Export as DOCX
        </MenuItem>

        <MenuItem
          onClick={() => {
            setMenuAnchorEl(null);
            getDocumentAs('pdf');
          }}
        >
          Export as PDF
        </MenuItem>
      </Menu>
    </>
  );
};
export default CapaExportButton;
